import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { NgRedux, select } from '@ptl/angular-redux-store';
import { StateStructure } from '@ptl/state';
import { saveMedigapValuesPostFormSubmit, plansNeedRefreshedFromBackend } from 'src/app/angular-elements/plan-selection/configs/reducers/plans.reducer';
import { Observable } from 'rxjs';
import { GlobalShadowStyleDirective } from '@ptl/global-components';

@Component({
    selector: 'app-whole-health-balance-checkbox',
    templateUrl: './whole-health-balance-checkbox.component.html',
    styleUrls: ['./whole-health-balance-checkbox.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    standalone: false
})

export class WholeHealthBalanceCheckboxComponent extends GlobalShadowStyleDirective implements OnInit {

  @Input() whbCheckboxTooltip: string;
  @Input() whbCheckboxLabel: string;
  @Input() variation?: string = 'checkbox';

  @select(['componentStates', 'Plans', 'medigapValuesPostFormSubmit'])
  medigapValuesPostFormSubmit$: Observable<any>;
  medigapValuesPostFormSubmit: any;

  whbChecked: boolean;

  constructor(
    private ngRedux: NgRedux<StateStructure>
  ) { 
    super();
  }

  ngOnInit() {

    this.medigapValuesPostFormSubmit$.subscribe((value) => {
      this.medigapValuesPostFormSubmit = value || {};

      if (typeof this.medigapValuesPostFormSubmit.whb == 'string') {
        this.whbChecked = this.medigapValuesPostFormSubmit.whb?.toLowerCase().trim() === 'true'
      }
      else {
        this.whbChecked = !!this.medigapValuesPostFormSubmit.whb;
      }
    });
  }

  async saveMedigapDataToState(checkboxValue) {

    this.medigapValuesPostFormSubmit.whb = checkboxValue;
    this.ngRedux.dispatch(saveMedigapValuesPostFormSubmit(this.medigapValuesPostFormSubmit));

    /** Indicate  */
    if (this.variation === 'checkbox') {
      this.ngRedux.dispatch(plansNeedRefreshedFromBackend(true));
    }
  }
}
